import { Box, Button, Divider, Tab, Tabs, Typography } from '@mui/material'
import React from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getClosetsBuckets } from 'services/closets/closets.service'

type Bucket = {
	page: number
	from: number
	to: number
	count: number
}

const BUCKET_SIZE = 250

const formatNumber = (n: number) => n.toLocaleString('ru-RU').replace(/,/g, ' ')

export const ClosetsManageSelect = () => {
	const navigate = useNavigate()
	const [tab, setTab] = React.useState<'male' | 'female'>('male')

	const handleChangeTab = (_: React.SyntheticEvent, newValue: 'male' | 'female') => {
		setTab(newValue)
	}

	const { data: maleData, isLoading: maleLoading } = useQuery(['getClosetsBuckets', 'male'], () =>
		getClosetsBuckets({ category: 'male', per_page: BUCKET_SIZE })
	)
	const { data: femaleData, isLoading: femaleLoading } = useQuery(['getClosetsBuckets', 'female'], () =>
		getClosetsBuckets({ category: 'female', per_page: BUCKET_SIZE })
	)

	const buckets: Bucket[] = (tab === 'male' ? maleData?.data : femaleData?.data) ?? []
	const isLoading = tab === 'male' ? maleLoading : femaleLoading

	return (
		<div>
			<Box display='flex' justifyContent='space-between' p={2}>
				<Typography variant='title_2'>Управление шкафами</Typography>
			</Box>
			<Divider />
			<Box sx={{ width: '100%' }} mb={2} py={4} display='flex' justifyContent='center'>
				<Tabs value={tab} onChange={handleChangeTab} aria-label='changing room tabs'>
					<Tab value='male' label='Мужская раздевалка' wrapped />
					<Tab value='female' label='Женская раздевалка' />
				</Tabs>
			</Box>
			<Divider />
			<Box display='flex' justifyContent='center' mt={7}>
				<Box display='flex' flexWrap='wrap' sx={{ width: 496 }} gap={2}>
					{isLoading && (
						<Box width='100%' display='flex' justifyContent='center' py={4}>
							<Typography color='primary.gray'>Загрузка…</Typography>
						</Box>
					)}
					{!isLoading && buckets.length === 0 && (
						<Box width='100%' display='flex' justifyContent='center' py={4}>
							<Typography color='primary.gray'>Шкафы не найдены</Typography>
						</Box>
					)}
					{buckets.map(bucket => (
						<Box key={`${tab}-${bucket.page}`}>
							<Button
								onClick={() =>
									navigate(`/management_closet?gender=${tab}&from=${bucket.from}&to=${bucket.to}`)
								}
							>
								<Box
									display='flex'
									flexDirection='column'
									justifyContent='center'
									alignItems='center'
									sx={{
										backgroundColor: '#F6F6F6',
										width: 240,
										height: 120,
										borderRadius: '12px'
									}}
								>
									<Typography variant='body_1' color='primary.black'>
										{formatNumber(bucket.from)}–{formatNumber(bucket.to)}
									</Typography>
									<Typography variant='footnote_2' color='primary.gray' mt={0.5}>
										{bucket.count} шкафов
									</Typography>
								</Box>
							</Button>
						</Box>
					))}
				</Box>
			</Box>
		</div>
	)
}
